<template>
  <div class="app">
    <!-- Date and Time Section -->
    <div class="datetime-header" v-if="authStore.isAuthenticated && $route.path !== '/setup-account'">
      <div class="current-date">{{ currentDate }}</div>
      <div class="current-time">{{ currentTime }}</div>
    </div>
    
    <header class="header" v-if="authStore.isAuthenticated && $route.path !== '/setup-account'">
      <div class="nav-container">
        <div class="left-section">
          <div class="logo">
            <img src="https://www.dof.gov.ph/wp-content/uploads/2024/02/DOF.png" alt="DOF Logo" class="logo-img">
            <h1 class="logo-text">Legislative Monitoring Portal</h1>
          </div>
          <div class="user-profile mobile-user" @click="toggleUserMenu">
            <div class="user-icon">👤</div>
            <div class="user-dropdown" :class="{ show: userMenuOpen }">
              <router-link to="/manage-accounts" @click="closeUserMenu">Manage Accounts</router-link>
				<router-link to="/manage-calendar" @click="closeUserMenu" v-if="authStore.user.role.includes('admin') || authStore.user.role.includes('lld-dc')">Manage Legislative Calendar</router-link>
              <router-link to="/change-password" @click="closeUserMenu">Change Password</router-link>
              <a href="#" @click="logout">Logout</a>
            </div>
          </div>
          <nav class="nav" :class="{ active: menuOpen }">
          <router-link to="/" @click="closeMenu">Home</router-link>
          <div class="dropdown" @mouseenter="openDropdown('showDropdown')" @mouseleave="scheduleCloseDropdown('showDropdown')">
            <a href="#" class="dropdown-toggle">Legislative Information</a>
            <div class="dropdown-menu" :class="{ show: showDropdown }">
              <router-link to="/committees" @click="closeMenu">Committees</router-link>
              <router-link to="/senators" @click="closeMenu">Senators</router-link>
              <router-link to="/representatives" @click="closeMenu">Representatives</router-link>
              <router-link to="/agencies" @click="closeMenu">Agencies</router-link>
              <router-link to="/news" @click="closeMenu">News</router-link>
            </div>
          </div>
          <div class="dropdown" @mouseenter="openDropdown('showReferencesDropdown')" @mouseleave="scheduleCloseDropdown('showReferencesDropdown')">
            <a href="#" class="dropdown-toggle">Legislative References</a>
            <div class="dropdown-menu" :class="{ show: showReferencesDropdown }">
              <a href="https://www.officialgazette.gov.ph/constitutions/1987-constitution/" target="_blank" @click="closeMenu">The 1987 Constitution of the Philippines</a>
              <a href="https://senate.gov.ph/hq/uploads/stand_alone/pdfs/16394881-a838-4d3e-90ee-af89cede94b7.pdf" target="_blank" @click="closeMenu">The Rules of the Senate</a>
              <a href="https://docs.congress.hrep.online/download/docs/hrep.house.rules.adopted.ebook.pdf" target="_blank" @click="closeMenu">The Rules of the House</a>
              <a href="https://senate.gov.ph/legislative-documents/journals" target="_blank" @click="closeMenu">Senate Legislative Plenary Journals</a>
              <a href="https://www.congress.gov.ph/legislative-documents/house-journals/" target="_blank" @click="closeMenu">House Legislative Plenary Journals</a>
              <a href="https://www.officialgazette.gov.ph/downloads/1991/10oct/19911010-RA-7160-CCA.pdf" target="_blank" @click="closeMenu">The Local Government Code of the Philippines</a>
              <a href="https://ntrc.gov.ph/tax-info/tax-laws-issuances/republic-acts/amendments-to-nirc" target="_blank" @click="closeMenu">Amendments to the National Internal Revenue Code (NIRC)</a>
              
            </div>
          </div>
			<div class="dropdown" @mouseenter="openDropdown('showDocumentsDropdown')" @mouseleave="scheduleCloseDropdown('showDocumentsDropdown')">
            <a href="#" class="dropdown-toggle">Legislative Documents</a>
            <div class="dropdown-menu" :class="{ show: showDocumentsDropdown }">
            
              <router-link to="/manage-subject-titles" @click="closeMenu">Subject Titles</router-link>
              <a href="#" @click="openBillsByUrgency">Bills by Legislative Status</a>
              <router-link to="/red-bills" @click="closeMenu">RED Bills</router-link>
              <a href="#" @click="openLedacBills">LEDAC</a>
              <a href="#" @click="openAdvancingBills">Urgent Bills</a>
              <router-link to="/committee-meetings" @click="closeMenu">Committee Meeting/Highlights</router-link>

            </div>
          </div>
          <div class="dropdown" @mouseenter="openDropdown('showTrackerDropdown')" @mouseleave="scheduleCloseDropdown('showTrackerDropdown')">
            <a href="#" class="dropdown-toggle">Tracker</a>
            <div class="dropdown-menu" :class="{ show: showTrackerDropdown }">
              <router-link to="/referrals" @click="closeMenu">PLLG Tracker</router-link>
              <router-link to="/lo-tracker" @click="closeMenu" v-if="authStore.user.role.includes('admin') || authStore.user.role.includes('lo-staff') || authStore.user.role.includes('pllg-dc-liaison')">LO Tracker</router-link>
              <router-link to="/ao-tracker" @click="closeMenu" v-if="authStore.user.role.includes('admin') || authStore.user.role.includes('account-officer') || authStore.user.role.includes('pllg-dc-policy')">Account Officer Tracker</router-link>
            </div>
          </div>
          <div class="dropdown" @mouseenter="openDropdown('showContactDropdown')" @mouseleave="scheduleCloseDropdown('showContactDropdown')">
            <a href="#" class="dropdown-toggle">Contact Us</a>
            <div class="dropdown-menu" :class="{ show: showContactDropdown }">
              <router-link to="/request-position-paper" @click="closeMenu">Request a copy of the Position Paper</router-link>
              <router-link to="/dof-dllos-contact" @click="closeMenu">DOF DLLOs contact</router-link>
            </div>
          </div>
          </nav>
        </div>
        <div class="user-profile desktop-user" @click="toggleUserMenu">
          <div class="user-icon">👤</div>
          <div class="user-dropdown" :class="{ show: userMenuOpen }">

            <router-link to="/manage-accounts" @click="closeUserMenu" v-if="authStore.user.role.includes('admin')">Manage Accounts</router-link>
            <router-link to="/manage-calendar" @click="closeUserMenu" v-if="authStore.user.role.includes('admin') || authStore.user.role.includes('lld-dc')">Manage Legislative Calendar</router-link>
            <router-link to="/manage-lo-assignment" @click="closeUserMenu" v-if="authStore.user.role.includes('admin')">Manage LO Assignment</router-link>

            <router-link to="/change-password" @click="closeUserMenu">Change Password</router-link>
            
            <a href="#" @click="logout">Logout</a>
          </div>
        </div>

        <button class="menu-toggle" @click="toggleMenu">☰</button>
      </div>
    </header>
    
    <!-- Notice of Committee Meetings -->
    <div class="notice-bar" v-if="authStore.isAuthenticated && $route.path !== '/setup-account'">
      <!-- <span class="notice-icon">📢</span> -->
      <!-- <span class="notice-text">{{ currentNotice }}</span> -->
    </div>
    <main class="main" :class="{ 'no-header': !authStore.isAuthenticated }">
      <router-view />
    </main>
  </div>
</template>

<script>
import { authStore } from './store/auth.js'
import api from '../src/axios.js'

export default {
  data() {
    return {
      currentDate: '',
      currentTime: '',
      currentNotice: '',
      noticeIndex: 0,
      notices: [
        'Committee on Finance meeting scheduled for Dec 16, 2024 at 10:00 AM - Room 101',
        'Ways and Means Committee hearing on Tax Reform Bill - Dec 17, 2024 at 2:00 PM',
        'Appropriations Committee budget review session - Dec 18, 2024 at 9:00 AM'
      ],
      menuOpen: false,
      showDropdown: false,
      showReferencesDropdown: false,
      showDocumentsDropdown: false,
      showContactDropdown: false,
	  showTrackerDropdown: false,
      userMenuOpen: false,
      dropdownTimeout: null
    }
  },
  computed: {
    authStore() {
      return authStore
    }
  },
  watch: {
    '$route'() {
      this.userMenuOpen = false
      this.menuOpen = false
      this.showDropdown = false
      this.showReferencesDropdown = false
      this.showDocumentsDropdown = false
      this.showContactDropdown = false
	  this.showTrackerDropdown = false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
      this.showDropdown = false
      this.showReferencesDropdown = false
      this.showDocumentsDropdown = false
      this.showContactDropdown = false
	  this.showTrackerDropdown = false
    },
    openDropdown(key) {
      // Cancel any pending close
      if (this.dropdownTimeout) {
        clearTimeout(this.dropdownTimeout)
        this.dropdownTimeout = null
      }
      // Close all other dropdowns first
      this.showDropdown = false
      this.showReferencesDropdown = false
      this.showDocumentsDropdown = false
      this.showContactDropdown = false
	  this.showTrackerDropdown = false
      // Open the target
      this[key] = true
    },
    scheduleCloseDropdown(key) {
      this.dropdownTimeout = setTimeout(() => {
        this[key] = false
      }, 150)
    },
    toggleUserMenu(event) {
      event.stopPropagation()
      this.userMenuOpen = !this.userMenuOpen
    },
    closeUserMenu() {
      this.userMenuOpen = false
    },
    handleClickOutside(event) {
      // Close user menu if clicking outside
      if (this.userMenuOpen) {
        const desktopUser = this.$el.querySelector('.desktop-user')
        const mobileUser = this.$el.querySelector('.mobile-user')
        if (desktopUser && !desktopUser.contains(event.target) &&
            mobileUser && !mobileUser.contains(event.target)) {
          this.userMenuOpen = false
        } else if (desktopUser && !desktopUser.contains(event.target) && !mobileUser) {
          this.userMenuOpen = false
        }
      }
      // Close nav dropdowns if clicking outside header
      const header = this.$el.querySelector('.header')
      if (header && !header.contains(event.target)) {
        this.showDropdown = false
        this.showReferencesDropdown = false
        this.showDocumentsDropdown = false
        this.showContactDropdown = false
		this.showTrackerDropdown = false
      }
    },
    updateDateTime() {
      const now = new Date()
      this.currentDate = now.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
      this.currentTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    updateNotice() {
      this.currentNotice = this.notices[this.noticeIndex]
      this.noticeIndex = (this.noticeIndex + 1) % this.notices.length
    },
    logout() {
      this.userMenuOpen = false
      authStore.logout()
      this.$router.push('/login')
    },
    async openAdvancingBills() {
      try {
        const response = await api.get('/advancing-bills/print', { responseType: 'blob' })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Error opening advancing bills PDF:', error)
      }
    },
    async openBillsByUrgency() {
      try {
        const response = await api.get('/bills-by-urgency/print', { responseType: 'blob' })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Error opening advancing bills PDF:', error)
      }
    }
  },
  mounted() {
    this.updateDateTime()
    this.updateNotice()
    setInterval(() => {
      this.updateDateTime()
    }, 1000)
    setInterval(() => {
      this.updateNotice()
    }, 5000)
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style>
.app {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
  color: white;
  padding: 0 1rem;
  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.3);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 2rem;
  height: 60px;
  position: relative;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.left-section {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.logo-img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  color: #fbbf24;
}

.search-container {
  position: absolute;
  right: 60px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  padding: 0.5rem;
  margin: 0.5rem;
}

.search-input {
  background: transparent;
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  outline: none;
  width: 250px;
  font-size: 0.9rem;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.search-btn {
  background: #fbbf24;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.search-btn:hover {
  background: #f59e0b;
  transform: scale(1.05);
}

.nav {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  white-space: nowrap;
}

.nav a {
  color: white;
  text-decoration: none;
  padding: 0.75rem 1rem;
  font-weight: 500;
  font-size: 0.9rem;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.nav a::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: #fbbf24;
  transition: all 0.3s;
  transform: translateX(-50%);
  border-radius: 2px;
}

.nav a:hover {
  color: #fbbf24;
  transform: translateY(-2px);
}

.nav a:hover::before {
  width: 80%;
}

.nav a.router-link-active {
  color: white;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: #fbbf24;
  text-underline-offset: 4px;
  text-decoration-thickness: 2px;
}

.dropdown {
  position: relative;
}

.dropdown-toggle {
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #1e40af;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.4);
  border-radius: 8px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s;
  z-index: 1000;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu a {
  display: block;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0;
}

.dropdown-menu a:last-child {
  border-bottom: none;
  border-radius: 0 0 4px 4px;
}

.dropdown-menu a:first-child {
  border-radius: 4px 4px 0 0;
}

.user-profile {
  position: relative;
  cursor: pointer;
}

.user-icon {
  width: 40px;
  height: 40px;
  background: rgba(251, 191, 36, 0.2);
  border: 2px solid #fbbf24;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s;
}

.user-icon:hover {
  background: #fbbf24;
  transform: scale(1.05);
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: #1e40af;
  min-width: 180px;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.4);
  border-radius: 8px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s;
  z-index: 10000;
  margin-top: 0.5rem;
}

.user-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.user-dropdown a {
  display: block;
  padding: 0.75rem 1rem;
  color: white;
  text-decoration: none;
  border-bottom: 1px solid rgba(59, 130, 246, 0.3);
  transition: background 0.3s;
}

.user-dropdown a:hover {
  background: #3b82f6;
}

.user-dropdown a:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}

.user-dropdown a:first-child {
  border-radius: 8px 8px 0 0;
}

.mobile-user {
  display: none;
}

.desktop-user {
  display: block;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  margin: 0.5rem;
}

.datetime-header {
  background: #1e3a8a;
  color: white;
  padding: 0.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  border-bottom: 1px solid rgba(251, 191, 36, 0.3);
}

.current-date {
  font-weight: 500;
}

.current-time {
  font-weight: 600;
  color: #fbbf24;
}

.notice-bar {
  background: linear-gradient(90deg, #fbbf24 0%, #f59e0b 100%);
  color: #1e3a8a;
  padding: 0.5rem 2rem;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
  white-space: nowrap;
}

.notice-icon {
  font-size: 1rem;
}

.notice-text {
  animation: scroll-text 20s linear infinite;
}

@keyframes scroll-text {
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
}

.main {
  flex: 1;
  overflow-y: auto;
}

.main.no-header {
  height: 100vh;
}

@media (max-width: 768px) {
  .nav-container {
    justify-content: space-between;
    flex-wrap: wrap;
    height: auto;
    padding: 0.5rem 0;
  }
  
  .logo {
    position: static;
  }
  
  .search-container {
    position: static;
    width: 100%;
    margin-top: 0.5rem;
    order: 3;
    right: auto;
  }
  
  .search-input {
    width: 100%;
  }
  
  .mobile-user {
    display: block;
  }
  
  .desktop-user {
    display: none;
  }
  
  .menu-toggle {
    display: block;
  }
  
  .nav {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    background: #1e3a8a;
    flex-direction: column;
    padding: 1rem;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
    align-items: stretch;
    z-index: 9999;
  }
  
  .nav.active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }
  
  .nav a {
    padding: 1rem;
    border-bottom: 1px solid rgba(59, 130, 246, 0.3);
  }
  
  .dropdown {
    width: 100%;
  }
  
  .dropdown-menu {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: none;
    box-shadow: none;
    background: #3b82f6;
    margin-left: 1rem;
  }
  
  .dropdown-menu.show {
    display: block;
  }
}
</style>